import React from 'react'

const ContactForm = () => {
  return (
    <section className='py-24'>

      <div className='container mx-auto lg:px-0'>
        <div className='text-center'>
          <div className='font-tertiary uppercase text-[15px] tracking-[6px]'>
            Skontaktuj się z nami
          </div>
          <h2 className='font-primary text-[45px] mb-4'>Kontakt</h2>
        </div>
            <form className='shadow-gray-300 shadow-xl h-96 lg:w-1/2 mx-auto py-5 flex flex-col items-center justify-evenly'>
                <input className='border border-gray-200 rounded p-1 w-4/5 placeholder:text-gray-400' placeholder='Imie i nazwisko'></input>
                <input className='border border-gray-200 rounded p-1 w-4/5 placeholder:text-gray-400' placeholder='Email'></input>
                <input className='border border-gray-200 rounded p-1 w-4/5 placeholder:text-gray-400' placeholder='Telefon'></input>
                <textarea className='border border-gray-200 rounded p-1 w-4/5 min-h-[160px] placeholder:text-gray-400' placeholder='Treść wiadomości'/>
                <button className='font-tertiary bg-accent hover:bg-accent-hover text-white px-10 py-2' type='submit'>Wyślij</button>
            </form>
      </div>
      <h3 className='font-tertiary uppercase text-[15px] tracking-[6px] text-center my-10'>
            Lub zadzwoń
          </h3>
          <a className='font-primary text-[45px] mb-4 text-center' href="tel:+48 536801333">+48 536 801 333</a>
          
    </section>
  )
}

export default ContactForm